<template>
    <div class="workouts-list">
        <div class="container">
            <div class="row">
                <div class="col-md-4 mb-5 card-banners" v-for="banner in upperBanners" :key="banner.ID">
                    <TreineBanner :banner="banner" :area="'primeiro-treino'"></TreineBanner>
                </div>
                <div class="col-md-4 mb-5" v-for="workout in workouts" :key="workout.ID">
                    <WorkoutCard :workout="workout"></WorkoutCard>
                </div>
                <div class="col-md-4 mb-5 card-banners" v-for="banner in bottomBanners" :key="banner.ID">
                    <TreineBanner :banner="banner" :area="'treino'"></TreineBanner>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import TreineBanner from '@/components/TreineBanner'
import WorkoutCard from '@/components/WorkoutCard'

export default {
    props : [ 'workouts' ],
    components : {
        WorkoutCard, TreineBanner
    },
    data () {
        return {
            bottomBanners: [],
            upperBanners: []
        }
    },
    computed: {
        ...mapGetters([
            'banners',
            'theme'
        ]),
    },
    watch : {
        banners() {
            this.bottomBanners = this.filterBannersByArea('treino')
            this.upperBanners = this.filterBannersByArea('primeiro-treino')
        }
    },
    methods: {
        filterBannersByArea(area) {
            return this.banners.filter(b => b.areas.includes(area))
        }
    },
    created() {
        this.bottomBanners = this.filterBannersByArea('treino')
        this.upperBanners = this.filterBannersByArea('primeiro-treino')
    }
}
</script>

<style lang="scss" scoped>
    @import "@/assets/scss/settings/_variables.scss";

    .banner {
        &__mobile {
            @media screen and (min-width: 769px){
                display: none;
            }
        }

        &__desktop {
            display: none;

            @media screen and (min-width: 769px){
                display: block;
            }
        }
    }
    .card-banners {
        /deep/ img {
            border: 2px solid transparent;
            border-radius: 10px;
            &:hover { border-color: $c_primary; }
        }
    }
</style>
